<template>
    <div>
        <!-- <base-header type="gradient-success" class="pb-6 pt-6 pt-md-2">

        </base-header>  -->
        <div class="card shadow p-0 mt-3">
            <b-container class="p-0">
                <div class="card-body p-0">
                    <div class="row mt-3">
                        <b-col>
                             <a @click="$router.go(-1)"><i class="fa fa-arrow-left" aria-hidden="true"></i></a>
                            <!-- <button 
                                type="button"    
                                @click="hasHistory() 
                                    ? $router.go(-1) 
                                    : $router.push('/')" class="btn btn-outline-success float-left mr-5 btn-sm">&laquo; 
                                    {{$t('message.backtap')}}
                            </button> -->
                            <section class="container" id="appointment-table">
                                <div class="appointment-table-header my-2">
                                    <div class="card-title">
                                    <h3> Modifier une affiliation</h3>
                                    </div>
                                </div>
                            </section>
                        </b-col>
                    </div>
                    
                    <form @submit.prevent="onSubmit" class="p-0">
                         <h4 class="ml-3"> Informations de l'affilié</h4>
                        <div class="row p-0">
                            <div class="col-md-6">
                                <div class="row p-0">
                                    <div class="form-group col-md-9 p-0">
                                        <span class="obligatoire">*</span>
                                        <label for="souscripteur_search">Souscripteur</label>
                                        <autocomplete
                                            :search="getSouscripteurs"
                                            placeholder="Recherchez le souscripteur"
                                            aria-label="Recherchez le souscripteur"
                                            :get-result-value="getValueSouscripteur"
                                            :default-value="CheckifDefaultSouscripteur"
                                            @submit="chooseSouscripteur"
                                        ></autocomplete>
                                        <input type="hidden" name="souscripteur_id" id="souscripteur_id" v-model="souscripteur_id" class="form-control" v-validate="'required'" :class="errors.has('souscripteur_id') ? 'is-invalid' : ''"/>
                                        <small id="emailHelp" class="form-text text-danger">{{ errors.has('souscripteur_id') ? "Rassurez-vous d'avoir sélectionné un souscripteur" :"" }}</small> 
                                    </div>
                                    <div class="form-group col-md-3 mt-0 mt-sm-5">
                                        <router-link :to="{ name: 'add-subscriber', params:{role: 'ama'}}">
                                        <i class="fas fa-plus-circle edit-icon"></i>
                                        <span class="nav-link-text"> {{$tc("message.subscribers")}}</span>
                                        </router-link>
                                    </div>
                                    <!-- <div class="form-group col-md-3 mt-1">
                                        <button class="btn btn-primary mt-4">+</button>
                                    </div> 
                                    
                                     -->
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="row p-0">
                                    <div class="form-group col-md-9 p-0">
                                        <span class="obligatoire">*</span>
                                        <label for="exampleInputEmail1">Patient</label>
                                        <autocomplete
                                            :search="getPatients"
                                            placeholder="Rechercher le patient"
                                            aria-label="Rechercher le patient"
                                            :get-result-value="getValueSouscripteur"
                                            :default-value="CheckifDefaultPatient"
                                            @submit="choosePatient"
                                        ></autocomplete>
                                        <input type="hidden" name="patient_id" id="patient_id" v-model="patient_id" class="form-control" v-validate="'required'" :class="errors.has('patient_id') ? 'is-invalid' : ''"/>
                                        <small id="emailHelp" class="form-text text-danger">{{ errors.has('patient_id') ? "Rassurez-vous d'avoir sélectionné un patient" :"" }}</small> 
                                    </div>
                                    <div class="form-group col-md-3 mt-0 mt-sm-5">
                                        <router-link :to="{ name: 'add-patient', params:{role: 'ama'}}">
                                        <i class="fas fa-plus-circle edit-icon"></i>
                                        <span class="nav-link-text"> {{$t("message.patient")}}</span>
                                        </router-link>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group col-md-6">
                                <span class="obligatoire">*</span>
                                <label for="package_id">Package</label>
                                <select name="package_id" id="package_id" v-model="package_id" class="form-control" v-validate="'required'" :class="errors.has('package_id') ? 'is-invalid' : ''">
                                    <option value="">Sélectionnez le package correspondant</option>
                                    <option v-for="(offre, key) in packages" :key="key" :value="offre.id">{{ offre.description_fr }} {{ offre.montant }} euros</option>
                                </select>
                                <small id="emailHelp" class="form-text text-danger">{{ errors.has('package_id') ? "Le package est requis" : "" }}</small> 
                            </div>
                            <div class="form-group col-md-6">
                                <span class="obligatoire">*</span>
                                <label for="date_debut">Date de début</label>
                                <input type="date" name="date_debut" id="date_debut" v-model="date_debut" class="form-control" v-validate="'required'" :class="errors.has('date_debut') ? 'is-invalid' : ''">
                                <small id="emailHelp" class="form-text text-danger">{{ errors.has('date_debut') ? "La date de début est requise" : "" }}</small> 
                            </div>
                            <div class="form-group col-md-6">
                                <span class="obligatoire">*</span>
                                <label for="niveau_urgence">Niveau d'urgence</label>
                                <select name="niveau_urgence" id="niveau_urgence" v-model="niveau_urgence" class="form-control"  v-validate="'required'" :class="errors.has('niveau_urgence') ? 'is-invalid' : ''">
                                    <option value="">Sélectionnez le niveau d'urgence</option>
                                    <option v-for="niveau in NiveauxUrgences" :value="niveau">{{ niveau }}</option>
                                </select>
                                <small id="emailHelp" class="form-text text-danger">{{ errors.has('niveau_urgence') ? "Le niveau d'urgence est requis" : "" }}</small> 
                            </div>
                            <div class="form-group col-md-6">
                                <span class="obligatoire">*</span>
                                <label for="status_paiement">Statut de paiement</label>
                                <select name="status_paiement" id="status_paiement" v-model="status_paiement" class="form-control"  v-validate="'required'" :class="errors.has('status_paiement') ? 'is-invalid' : ''">
                                    <option value="">Sélectionnez le statut de paiement</option>
                                    <option v-for="statut in statutsPaiements" :value="statut">{{ statut }}</option>
                                </select>
                                <small id="emailHelp" class="form-text text-danger">{{ errors.has('status_paiement') ? "Le statut de paiement est requis" : "" }}</small> 
                            </div>
                            <div class="form-group col-md-12">
                                <span class="obligatoire">*</span>
                                <label for="plainte" class="typo__label">Plaintes</label>
                                <multiselect v-model="plaintes" id="plainte" tag-placeholder="Ajouter une nouvelle plainte" :taggable="true" @tag="addTag" label="description" track-by="id" placeholder="Rechercher ou ajouter une plainte" :options="liste_plaintes" :multiple="true" :searchable="true" :loading="loading" :internal-search="false" :clear-on-select="false" :close-on-select="false" :options-limit="30" :max-height="600" :show-no-results="false" :hide-selected="true" @search-change="getMotifs">
                                    <template slot="clear" slot-scope="props">
                                        <div class="multiselect__clear" v-if="plaintes.length" @mousedown.prevent.stop="clearAll(props.search)"></div>
                                    </template><span slot="noResult">Ajouter une nouvelle plainte</span>
                                </multiselect>
                                <small id="emailHelp" class="form-text text-danger">{{ errors.has('plaintes') ? "Les plaintes sont requises" : "" }}</small> 
                            </div>
                            <b-col>
                                <div>
                                    <b-form-select name="selected" id="selected" v-model="selected" :options="options" v-validate="'required'" :class="errors.has('selected') ? 'is-invalid' : ''"></b-form-select>
                                    <!-- <select name="niveau_urgence" id="niveau_urgence" v-model="niveau_urgence" class="form-control"  v-validate="'required'" :class="errors.has('niveau_urgence') ? 'is-invalid' : ''"> -->
                                    <small id="emailHelp" class="form-text text-danger">{{ errors.has('selected') ? "Ce champ est requis" : "" }}</small> 
                                    <!-- <div class="mt-3">Selected: <strong>{{ selected }}</strong></div> -->
                                </div>
                            </b-col>
                        </div>
                        <label class="mt-3 ml-3" for="paye_par_affilie">Les soins seront payés par l'affilié ?</label>
                        <div class="row ml-3">
                            <div class="custom-control custom-radio custom-control-inline mt-2">
                                <input type="radio" class="custom-control-input" v-model="paye_par_affilie" id="oui" checked value="Oui">
                                <label class="custom-control-label" for="oui">Oui</label>
                            </div>
                            <div class="custom-control custom-radio custom-control-inline mt-2">
                                <input type="radio" class="custom-control-input" v-model="paye_par_affilie" id="non" value="Non">
                                <label class="custom-control-label" for="non">Non</label>
                            </div>
                        </div>
                        <h4 class="mt-3 ml-3"> Informations de la personne à contacter</h4>
                        <div class="row">
                            <div class="form-group col-md-6">
                                <span class="obligatoire">*</span>
                                <label for="contact_name">Nom</label>
                                <input type="text" name="contact_name" id="contact_name" v-model="contact_name" class="form-control" v-validate="'required'" :class="errors.has('contact_name') ? 'is-invalid' : ''"/>
                                <small id="emailHelp" class="form-text text-danger">{{ errors.has('contact_name') ? "le nom est requis" : "" }}</small> 
                            </div>
                            <div class="form-group col-md-6">
                                <span class="obligatoire">*</span>
                                <label for="contact_firstName">Prénom</label>
                                <input type="text" name="contact_firstName" id="contact_firstName" v-model="contact_firstName" class="form-control" v-validate="'required'" :class="errors.has('contact_firstName') ? 'is-invalid' : ''"/>
                                <small id="emailHelp" class="form-text text-danger">{{ errors.has('contact_firstName') ? "le prénom est requis" : "" }}</small> 
                            </div>
                            <div class="form-group col-md-6">
                                <span class="obligatoire">*</span>
                                <label for="contact_phone">Contact</label>
                                <input type="text" name="contact_phone" id="contact_phone" v-model="contact_phone" class="form-control" v-validate="'required'" :class="errors.has('contact_phone') ? 'is-invalid' : ''"/>
                                <small id="emailHelp" class="form-text text-danger">{{ errors.has('contact_phone') ? "le contact est requis" : "" }}</small> 
                            </div>
                             <div class="form-group col-md-6">
                                <span class="obligatoire">*</span>
                                <label for="lien">Lien de parenté</label>
                                <select name="lien" id="lien" v-model="lien" class="form-control"  v-validate="'required'" :class="errors.has('lien') ? 'is-invalid' : ''">
                                    <option value="">Sélectionnez le lien de parenté</option>
                                    <option v-for="lien in liens" :value="lien.value">{{ lien.text }}</option>
                                </select>
                                <small id="emailHelp" class="form-text text-danger">{{ errors.has('lien') ? "Le lien de parenté est requis" : "" }}</small> 
                            </div>
                        </div>
                        <div class="d-flex justify-content-center" v-if="isLoading">
                            <div class="loading"></div>
                        </div>
                        <div v-else class="text-center mb-3">
                            <button type="submit" class="btn btn-primary">Modifier</button>
                        </div>
                         
                    </form>
                </div>
                
            </b-container>
        </div>
    </div>
    
</template>

<script>
    import { mapGetters } from 'vuex';

    import moment from 'moment';
    import _ from 'lodash';
    import Swal from 'sweetalert2';
    import { pagination, handlePaginationClick } from "../../helpers/paginations";
    import Autocomplete from '@trevoreyre/autocomplete-vue'
    import Multiselect from 'vue-multiselect'
    import '@trevoreyre/autocomplete-vue/dist/style.css'
    import axios from 'axios';
    import AppConfig from '../../constants/AppConfig';
    export default {
        name: "AddAffiliation",
         components: {
            Autocomplete, Multiselect
        },
        computed: {
            ...mapGetters(["affiliations",'hasAdminRole',
                'hasGestionnaireRole',
                'hasPraticienRole',
                'hasMedecinControleRole','hasAssistante'
            ]),

            can:function(){
                return this.hasAdminRole || this.hasGestionnaireRole || this.hasPraticienRole || this.hasMedecinControleRole || this.hasAssistante;
            },

            rows: function() {
                return this.affiliations.length;
            },
            CheckifDefaultPatient: function(){
                if(this.$route.params.prenom == null){
                    let pparams = JSON.parse(localStorage.getItem('pparams'));
                    if(pparams != null){
                        this.patient_label = pparams.nom +' '+pparams.prenom+' ('+pparams.email+')';
                        this.patient_id = pparams.id;
                    }

                }else{
                    localStorage.setItem('pparams', JSON.stringify(this.$route.params))
                    let pparams = this.$route.params;
                    this.patient_label = pparams.nom +' '+pparams.prenom+' ('+pparams.email+')'; 
                    this.patient_id = pparams.id;
                }
                return this.patient_label == '' ? this.$route.params.patient_label : this.patient_label;
            },
            CheckifDefaultSouscripteur: function(){
                if(this.$route.params.s_prenom == null){
                    let sparams = JSON.parse(localStorage.getItem('sparams'));
                    if(sparams != null){
                        this.souscripteur_label = sparams.s_nom +' '+sparams.s_prenom+' ('+sparams.s_email+')';
                        this.souscripteur_id = sparams.s_id;
                    }

                }else{
                    localStorage.setItem('sparams', JSON.stringify(this.$route.params))
                    let sparams = this.$route.params;
                    this.souscripteur_label = sparams.s_nom +' '+sparams.s_prenom+' ('+sparams.s_email+')'; 
                    this.souscripteur_id = sparams.s_id;
                }
                
                return this.souscripteur_label == '' ? this.$route.params.souscripteur_label : this.souscripteur_label;
            }
        },

        data() {
            return {
                selected: null,
                options: [
                    { value: null, text: "Par quel canal avez-vous entendu parler de Medicasure pour la 1ère fois ?" },
                    { value: 1, text: "Recommandattion d'un client" },
                    { value: 2, text: "WhatsApp" },
                    { value: 3, text: "Website" },
                    { value: 4, text: "Facebook" },
                    { value: 5, text: "Connaissance promoteur" },
                    // { value: 'b', text: 'Selected Option', disabled: true },
                ],
                plaintes: [],
                liste_plaintes: [],
                isLoading: false,
                souscripteur_id : '',
                souscripteur_search: '',
                patient_id: '',
                souscripteurs: [],
                packages: [],
                liens: [],
                package_id: '',
                niveau_urgence: '',
                lien: '',
                plainte: '',
                date_debut: '',
                contact_name: '',
                contact_firstName: '',
                contact_phone: '',
                NiveauxUrgences: [ 1, 2, 3, 4, 5 ],
                statutsPaiements: ['NON PAYE', 'PAYE'],
                nom: 'Annuelle',
                status_contrat: 'Généré',
                status_paiement: this.status_paiement,
                patient_label: this.$route.params.patient_label,
                souscripteur_label: '',
                routeSlug: this.$route.params.contrat,
                paye_par_affilie: '',
            }
        },
        watch:{
           
        },
        methods: {
            hasHistory () { return window.history.length > 2 },
            onRappelClick(id) {
                let args = {
                    subscriber: id,
                };
                    let successMessage = "Mail de rappel d'ajout de patient a été envoyé au souscripteur";
                    let errorMessages = {
                        generic: this.$i18n.t('message.genericError'),
                        error: this.$i18n.t('message.genericError') 
                    };                
                this.$store.dispatch('rappelSubscriber', { args, errorMessages, successMessage })
                .then(() => {

                });

            },
            viewAffiliation(slug){

                this.$router.push(  (this.$router.resolve({ name: 'affiliation',  params: { contrat: slug } })).href +  '#generale');

            },
            getSubscribers() {
                let args = {
                    offset: this.offset,
                    limit: this.limit
                };

                this.$store.dispatch('getSubscribersCim', { args : args });
            },
            getAffiliations() {
                let args = {
                    offset: this.offset,
                    limit: this.limit
                };
                this.$store.dispatch('getAffiliations', { args : args });
            },
            getPackages() {
                axios.get(AppConfig.apiUrl+'/offres', {headers: {'Authorization': "Bearer " + localStorage.getItem('ms-token')}}).then(res => {
                    let offres = res.data.offres.map(offre => offre.packages),
                    packages = [];
                    offres.forEach(offre => {
                        offre.forEach(item => {
                            packages.push(item);
                        })
                    });
                    this.packages = packages;
                }).catch(error => {
                    console.log('error ', error);
                })
            },

            onSubmit() {
                this.status_contrat = this.status_paiement == "NON PAYE" ? "Généré" : "Actif"
                var data = new FormData();
                data.append("souscripteur_id", this.souscripteur_id);
                data.append("patient_id", this.patient_id);
                data.append("package_id", this.package_id);
                data.append("niveau_urgence", this.niveau_urgence);
                data.append("plaintes", this.plaintes.map(item => item.id));
                data.append("date_debut", this.date_debut);
                data.append("contact_name", this.contact_name);
                data.append("contact_firstName", this.contact_firstName);
                data.append("contact_phone", this.contact_phone);
                data.append("nom", this.nom);
                data.append("status_contrat", this.status_contrat);
                data.append("status_paiement", this.status_paiement);
                data.append("lien", this.lien);
                data.append("selected", this.selected);
                data.append("paye_par_affilie", this.paye_par_affilie);
                this.$validator.validateAll().then((result) => {
                    if (result) 
                    {
                        fetch(AppConfig.apiUrl+'/affiliationRevueUpdate/'+this.$route.params.contrat, {headers: 
                            {
                                'Authorization': "Bearer " + localStorage.getItem('ms-token'),
                            },
                                method: 'POST',
                                body: data})
                            .then(res => res.json())
                            .then(res => {
                                if(res.error != null){
                                    Swal.fire({
                                        title: "Erreur",
                                        text: res.error.dejaAffilie[0],
                                        icon: 'error',
                                    })
                                }else{
                                    localStorage.removeItem("role");
                                    localStorage.removeItem("sparams");
                                    localStorage.removeItem("pparams");
                                    Swal.fire({
                                        title: "Opération réussie",
                                        text: "L'affiliation a été modifier avec succès",
                                        icon: 'success',
                                    })
                                    this.$router.push({ name: 'follow-up-souscripteur' });
                                }
                               
                            }).catch(error => {
                                console.log('error ', error);
                        }) 
                    }
                });
                if(this.$route.params.contrat){
                    // console.log('route',this.$route.params.contrat);
                }
               

            },
            getSouscripteurs(input) {
                return new Promise(resolve => {
                    if (input.length < 3) {
                    return resolve([])
                    }
                    fetch(AppConfig.apiUrl+'/search/souscripteurs/'+input, {headers: {'Authorization': "Bearer " + localStorage.getItem('ms-token')}})
                    .then(res => res.json())
                    .then(res => {
                        resolve(res.souscripteurs)
                    }).catch(error => {
                        console.log('error ', error);
                    })
                })
            },
            
            getPatientDetails() {
                fetch(AppConfig.apiUrl+'/affiliationRevueEdit/'+this.$route.params.contrat, {headers: 
                {
                    'Authorization': "Bearer " + localStorage.getItem('ms-token'),
                },
                    method: 'GET'
                    })
                .then(res => res.json())
                .then(res => {
                    this.contact_name = res.affiliation.contact_name,
                    this.contact_firstName = res.affiliation.contact_firstName,
                    this.contact_phone = res.affiliation.contact_firstName,
                    this.niveau_urgence = res.affiliation.niveau_urgence,
                    this.patient_id = res.affiliation.patient_id
                    this.date_debut = res.affiliation.date_debut,
                    this.status_paiement = res.affiliation.status_paiement,
                    this.package_id = res.affiliation.package_id,
                    this.plainte = res.affiliation.plainte,
                    this.selected = res.affiliation.selected,
                    this.souscripteur_id = res.affiliation.souscripteur_id;
                    this.paye_par_affilie = res.affiliation.paye_par_affilie;
                    this.plaintes = res.affiliation.motifs.map(item => ({id: item.id, description: item.description}));
                    this.liste_plaintes = res.affiliation.motifs.map(item => ({id: item.id, description: item.description}));
                    // paye_par_affilie: 'Non',
                    //this.souscripteur_label = res.affiliation.patient.user.nom +' '+res.affiliation.patient.user.prenom+' ('+res.affiliation.patient.user.email+')'
                    // this.souscripteur_label = res.affiliation.patient.souscripteur.nom +' '+pparams.prenom+' ('+pparams.email+')';

                }).catch(error => {
                    console.log('error ', error);
                })
                
            },


            getValueSouscripteur(result) {
                return result.user.nom +' '+result.user.prenom +' ('+result.user.email+')'
            },
            chooseSouscripteur(result) {
                this.souscripteur_id = result.user_id;
            },
            choosePatient(result) {
                this.patient_id = result.user_id;
            },
            
            getErrorsField(field){
                if (this.errorshasField(field)){
                    return this.errors[field][0];
                }else{
                    return  '';
                }
            },
              errorshasField(field){
                return this.errors ? this.errors.hasOwnProperty(field) : false;
                },
             getPatients(input) {
                return new Promise(resolve => {
                    if (input.length < 3) {
                    return resolve([])
                    }
                    fetch(AppConfig.apiUrl+'/search/patients/'+input, {headers: {'Authorization': "Bearer " + localStorage.getItem('ms-token')}})
                    .then(res => res.json())
                    .then(res => {
                        resolve(res.patients)
                    }).catch(error => {
                        console.log('error ', error);
                    })
                })
            },
            getLiens() {
            let self = this;
            fetch(AppConfig.apiUrl + "/liens", {
                method: "GET",
                headers: {
                "Content-Type": "application/json;charset=utf-8",
                },
            })
                .then(function (response) {
                return response.json();
                })
                .then(function (result) {
                    let qArray = [];

                    _.forOwn(result.liens, function(value, key) {
                        qArray.push({ text: value.fr_description, value: value.id });
                    });

                    self.liens = qArray;
                    self.lien = qArray[0].value;
                })
                .catch(function (error) {
                console.error("Error:", error);
                });
            },

            addTag (newTag) {
                const tag = {
                    id: "item_"+newTag,
                    description: newTag
                }
                this.liste_plaintes.push(tag)
                this.plaintes.push(tag)
            },

            getMotifs(motif){
                this.loading = true;
                fetch(AppConfig.apiUrl+`/search/motif/${motif}`, {headers: {'Authorization': "Bearer " + localStorage.getItem('ms-token')}})
                    .then(res => res.json())
                .then(res => {
                    this.loading = false;
                    this.liste_plaintes = res.motifs.map(item => ({id: item.id, description: item.description})).filter(item => item.description != "" && item.description != "[object Object]");
                }).catch(error => {
                    console.log('error ', error);
                })
            },
            clearAll () {
                this.plaintes = []
            }
            
        },

        mounted() {
            // Fetch subscriber list
            localStorage.setItem('role', 'ama');
            this.getPackages();
            this.getLiens();
            this.getPatientDetails();
        }
    }
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>

</style>